const ITEMS = ["Melbourne's Trusted Removalists", "From $69/hr", "Fully Insured", "Same Day Available"];

export const Marquee = () => (
  <div className="relative overflow-hidden border-y border-slate-800 bg-slate-900 py-10 lg:py-16" data-testid="marquee-section" aria-hidden="true">
    <div className="animate-marquee-slow flex w-max items-center gap-10 whitespace-nowrap">
      {[...Array(2)].map((_, dup) => (
        <div key={dup} className="flex items-center gap-10">
          {ITEMS.map((t, i) => (
            <span key={`${dup}-${i}`} className="flex items-center gap-10">
              <span className={`font-display text-6xl font-semibold uppercase tracking-tighter lg:text-8xl ${i % 2 === 0 ? "[-webkit-text-stroke:1.5px_rgba(255,255,255,0.3)] text-transparent" : "[-webkit-text-stroke:1.5px_rgba(96,165,250,0.8)] text-transparent"}`}>
                {t}
              </span>
              <span className="h-3 w-3 rotate-45 bg-blaze" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
